module.exports = __webpack_public_path__ + "assets/ranging.ed17b4dd.svg";